export const getUSAStateDetails = (stateOfUSA) => {

    const USAStatesMappings = [

        { name: 'Florida', category: 'A' },
        { name: 'Georgia', category: 'A' },
        { name: 'Illinois', category: 'A' },
        { name: 'Montana', category: 'A' },
        { name: 'New Jersey', category: 'A' },
        { name: 'North Carolina', category: 'A' },
        { name: 'Texas', category: 'A' },
        { name: 'Rhode Island', category: 'A' },
        { name: 'South Carolina', category: 'A' },
        { name: 'Pennsylvania', category: 'A' },
        { name: 'Washington', category: 'A' },
        { name: 'Wisconsin', category: 'A' },

        { name: 'North Dakota', category: 'B' },
        { name: 'Wyoming', category: 'B' },
        { name: 'Virginia', category: 'B' },
        { name: 'Utah', category: 'B' },
        { name: 'Oregon', category: 'B' },
        { name: 'Puerto Rico', category: 'B' },
        { name: 'South Dakota', category: 'B' },
        { name: 'Tennessee', category: 'B' },
        { name: 'New York', category: 'B' },
        { name: 'Alabama', category: 'B' },
        { name: 'Indiana', category: 'B' },
        { name: 'Nebraska', category: 'B' },
        { name: 'Nevada', category: 'B' },
        { name: 'New Hampshire', category: 'B' },
        { name: 'Maryland', category: 'B' },
        { name: 'Massachusetts', category: 'B' },
        { name: 'Michigan', category: 'B' },
        { name: 'Minnesota', category: 'B' },
        { name: 'Mississippi', category: 'B' },
        { name: 'Missouri', category: 'B' },
        { name: 'Kansas', category: 'B' },
        { name: 'Kentucky', category: 'B' },
        { name: 'Louisiana', category: 'B' },
        { name: 'Hawaii', category: 'B' },
        { name: 'Idaho', category: 'B' },
        { name: 'Connecticut', category: 'B' },
        { name: 'Delaware', category: 'B' },
        { name: 'District of Columbia', category: 'B' },
        { name: 'California', category: 'B' },
        { name: 'American Samoa', category: 'B' },

        { name: 'Alaska', category: 'C' },
        { name: 'Arizona', category: 'C' },
        { name: 'Arkansas', category: 'C' },
        { name: 'Colorado', category: 'C' },
        { name: 'Guam', category: 'C' },
        { name: 'Iowa', category: 'C' },
        { name: 'Maine', category: 'C' },
        { name: 'New Mexico', category: 'C' },
        { name: 'Northern Mariana Islands', category: 'C' },
        { name: 'Ohio', category: 'C' },
        { name: 'Oklahoma', category: 'C' },
        { name: 'U.S. Virgin islands', category: 'C' },
        { name: 'Vermont', category: 'C' },
        { name: 'West Virginia', category: 'C' }
    ];

        return USAStatesMappings.find(record => record.name === stateOfUSA);
};